import React from 'react';

import List from './status/List'

function Operator(){
	return(
	
			<List/>
			
		
	);
}

export default Operator;